<template>
  <div class="page-loader" aria-busy="true">
    <p class="sr-only" role="status">{{ label }}</p>
    <div class="page-loader-navbar">
      <skeleton class="h-7 w-36" />
      <skeleton class="size-10 rounded-md" />
    </div>
    <div class="page-loader-main">
      <div class="flex flex-col gap-2">
        <skeleton class="h-8 w-64" />
        <skeleton class="h-4 w-96 max-w-full" />
      </div>
      <div class="page-loader-cards">
        <skeleton v-for="n in 4" :key="n" class="h-28 w-full" />
      </div>
      <div class="mt-6 flex flex-col gap-3">
        <skeleton class="h-10 w-full" />
        <skeleton v-for="n in 6" :key="`row-${n}`" class="h-12 w-full" />
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from '@kate/components/ui';

export default {
  name: 'PageLoader',
  components: {
    Skeleton,
  },
  props: {
    label: {
      type: String,
      default: 'Loading',
    },
  },
};
</script>

<style scoped>
.page-loader {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  background: var(--kate-background-body);
}

.page-loader-navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 70px;
  padding: 0 28px;
  background: #0e0d1a;
}

.page-loader-main {
  width: 90%;
  margin: 20px auto 0;
}

.page-loader-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
  margin-top: 24px;
}
</style>
